import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { useListingNewsroomFrontpageQuery } from '../../../generated/queries';
import { isDefined } from '../../commons/is-defined';
import { Complete } from '../../commons/types';
import { buildDrupalImage } from '../Image';

type Slot = RouteSlotInput<typeof KitchenSinkRoute, 'body', 'HomeGridTeaser'>;

type SlotInput = Exclude<Slot['input'], Function>;

type GridItem = SlotInput['teasers'][number];

export function mapNewsroomFrontpage(
  input: ParagraphNewsroomFrontpageFragment,
): Slot {
  return {
    key: 'HomeGridTeaser',
    input: function useListingNewsroomFrontpage() {
      const { data, isLoading, isFetching } = useListingNewsroomFrontpageQuery({
        argument: input.argument,
        offset: 0,
        limit: 5,
      });

      const slotInput: Complete<SlotInput> = {
        title: input.title,
        teasers:
          data?.listingNewsroomFrontpage.items.filter(isDefined).map(
            (item): Complete<GridItem> => ({
              Link: buildLink({ href: item.path }),
              title: item.title,
              Image: item.teaserImage
                ? buildDrupalImage(item.teaserImage, 'teaser')
                : undefined,
              Description: undefined,
              date: item.date,
              arrowIsVisible: false,
              isFullWidth: false,
            }),
          ) || [],
        Link: buildLink({ href: '/newsroom' }),
      };

      return [
        slotInput,
        isLoading || isFetching
          ? 102
          : data
          ? data.listingNewsroomFrontpage.items.length > 0
            ? 200
            : 404
          : 0,
      ];
    },
  };
}
